/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React, { useContext } from "react";

import { FormModel } from "../../../shared/FormModel/FormModel";
import { bem } from "../../../shared/BEM";
import { useFormModel } from "../../../shared/hooks/useFormModel";
import { renderFormElementList } from "./renderFormElement";
import { ConfigContext } from "../../ConfigContext";
import { FormFieldTextComponent } from "./FormFieldTextComponent";
import { APP_VERSION } from "../../constants";
import { getDateString } from "../../../shared/formatting";

/**
 * Component props
 */
export interface IFormComponentProps {
	model: FormModel
}

export function FormComponent(props: IFormComponentProps) {

	const formState = useFormModel(props.model);
	const config = useContext(ConfigContext);

	const stl = bem("form");

	return <div className={stl.str}>
		<header className={stl.el("header").str}>
			{/* Logo */}
			<img className={stl.el("header-logo").str} src={`${config.assetsPath}/media/kuchyne_rondo_white_big.png`} alt="Kuchyně Rondo" />
			<h2 className={stl.el("header-title").str}>{formState.headerTitle}</h2>
		</header>
		<article className={stl.el("meta").str}>
			<FormFieldTextComponent element={props.model.getNameField()} />
			<FormFieldTextComponent element={props.model.getHeaderTitleField()} />
		</article>
		<article className={stl.el("content").str}>
			{renderFormElementList(formState.content)}
		</article>
		<article className={stl.el("footer").str}>
			<div className={stl.el("footer-row").str}>
				<div className={stl.el("footer-column").mod(["width-1-3", "align-left"]).str}>
					<ul>
						<li>Lucie Holá</li>
						<li><a href="tel:00420792319659">+420 792 319 659</a></li>
						<li><a href="mailto:holal@kuchynerondo.cz">holal@kuchynerondo.cz</a></li>
					</ul>
				</div>
				<div className={stl.el("footer-column").mod(["width-1-3", "align-center"]).str}>
					<p>
						<img className={stl.el("header-logo").str} src={`${config.assetsPath}/media/kuchyne_rondo_big_grayscale.png`} alt="Kuchyně Rondo" />
					</p>
					<p>
						<a href="http://www.kuchynerondo.cz/" target="_blank">www.kuchynerondo.cz</a>
					</p>
				</div>
				<div className={stl.el("footer-column").mod(["width-1-3", "align-right"]).str}>
					<ul>
						<li>Vladimír Štindl</li>
						<li><a href="tel:00420721613526">+420 721 613 526</a></li>
						<li><a href="mailto:stindl@kuchynerondo.cz">stindl@kuchynerondo.cz</a></li>
					</ul>
				</div>
			</div>
			{config.mode === "ssr" ?
				<div>
					<p className="subline">Vygenerováno aplikací RONDO Formuláře verze {APP_VERSION} dne {getDateString(new Date())}. ID dokumentu: {formState.id}</p>
				</div>
				: null}
		</article>
	</div>;

}